import type { ReactElement } from 'react';
import { TruncatedTextTooltip } from '../TruncatedTextTooltip';

export const renderDescription = (description?: string | ReactElement) => {
  if (typeof description === 'string') {
    return <TruncatedTextTooltip text={description} />;
  }
  return description;
};
